import { PromiseUtils } from '@amzn/ihm-associate-tools-js-lib'
import * as speechSynthesisService from '@services/speech/SpeechSynthesisService'

/**
 * Cross frame listener for speechSynthesis. It call speechSynthesis listener registered in Old seaward.
 *
 * Listens for speechSynthesis requests and forwards them to the speechSynthesisService.
 * Returns a promise from the speechSynthesis service.
 *
 * @param {object} message - Object with the following structure:
 *  {
 *      data: {
 *          action: {string} - one of 'speak', 'warmup', 'repeat'
 *          parameters: {object} - object containing the parameters for the speak call
 *      }
 *  }
 *  @return {Promise} - Promise for the specified action.
 */
export const listener = (message) => {
    const action = message && message.data && message.data.action
    const params = message && message.data && message.data.parameters

    switch (action) {
    case 'speak':
        return speechSynthesisService.speak(params)
    case 'warmup':
        return speechSynthesisService.warmup()
    case 'repeat':
        return speechSynthesisService.repeat()
    }

    return PromiseUtils.newRejectedPromiseWithErrorMessage('Unsupported action: ' + action)
}
